module.exports = __webpack_public_path__ + "img/business.35a07393.jpg";